import React, { type ReactNode } from 'react';
import { useAuth } from '../context/AuthContext';

type Props = {
  permission?: string;
  anyPermissions?: readonly string[];
  children: ReactNode;
  fallback?: ReactNode;
};

export function PermissionGuard({
  permission,
  anyPermissions,
  children,
  fallback = null,
}: Props) {
  const auth = useAuth();
  const allowedByPermission = permission
    ? auth.hasPermission(permission)
    : false;
  const allowedByAny = anyPermissions?.length
    ? auth.hasAnyPermission(anyPermissions)
    : false;
  const allowed =
    permission || anyPermissions?.length
      ? allowedByPermission || allowedByAny
      : false;
  return <>{allowed ? children : fallback}</>;
}
